<template>
  <div :class="{ 'is-invalid': isInvalid }">
    <multiselect
      v-model="value"
      @input="input"
      :options="options"
      label="name"
      track-by="name"
      :show-labels="false"
      :multiple="multiple"
    >
      <template slot="option" slot-scope="props">
        {{ props.option.name }}
      </template>
    </multiselect>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'

export default {
  name: 'wizard-multiselect',

  components: {
    Multiselect
  },

  props: {
    options: {
      type: Array,
      required: true
    },
    multiple: {
      type: Boolean,
      default: true
    },
    isInvalid: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      value: null
    }
  },

  methods: {
    input (e) {
      this.$emit('input', e)
    }
  }
}
</script>

<style lang='scss' scoped rel='stylesheet/scss'>
  @import '~@/styles/vars.scss';

  .is-invalid /deep/ .multiselect__tags {
    border-color: $color-red;
  }

  /deep/ .multiselect__tag {
    background: map_get($palette-primary, main);
  }

  /deep/ .multiselect__option--highlight {
    background: map_get($palette-primary, main);
  }

  /deep/ .multiselect__option--selected.multiselect__option--highlight {
    background: #FF6A6A;
  }

  /deep/ .multiselect__tag-icon:after {
    color: darken(map_get($palette-primary, main), 20%);
  }

  /deep/ .multiselect__tag-icon:focus,
  /deep/ .multiselect__tag-icon:hover {
    background: darken(map_get($palette-primary, main), 5%);
  }
</style>